import { Component, Input } from '@angular/core';
import {
    FrameworkColumn,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';
import { uniqBy } from 'lodash-es';

export interface TagsRendererProps {
    tagsFn: (
        value: SafeAny,
        row: SafeAny
    ) => { color: string; label: string }[];
}

@Component({
    selector: 'pf-action-renderer',
    template: ` @for (item of list; track item.label) {
        <nz-tag [nzColor]="item.color">{{ item.label }}</nz-tag>
    }`,
    styles: [
        `
            :host {
                nz-tag {
                    margin: 2px;
                    border-radius: 15px;
                }
            }
        `,
    ],
    standalone: false,
})
export class TagsRendererComponent
    implements ITableCellValueRenderer, TagsRendererProps
{
    list: { color: string; label: string }[] = [];

    @Input() tagsFn!: (
        value: SafeAny,
        row: SafeAny
    ) => { color: string; label: string }[];

    @Input() set value(value: SafeAny) {
        if (!value || !this.tagsFn) {
            return;
        }
        this.list = uniqBy(this.tagsFn(value, this.row), 'label');
    }

    @Input() column!: FrameworkColumn;
    @Input() row!: SafeAny;
}
